import { constants, mediaQueryStyles } from "@newsela/angelou";

const geniusAccentColor = "#11ACDB"; // Generations Genius accent color
const blue = {
  background: geniusAccentColor,
  player: geniusAccentColor,
};
const orange = {
  background: constants.colors.product.science[500],
  player: constants.colors.product.science[300],
};

const { mobileFirstCss } = mediaQueryStyles;

// Shared responsive values for padding and minWidth
const responsiveSpacing = ["1em", "1em", "44px", "64px"];

export const playerColor = (showBlueBackground: boolean) =>
  showBlueBackground ? blue.player : orange.player;

export const geniusVideoWrapperCss = (showBlueBackground: boolean = false) =>
  mobileFirstCss({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: `
      url("/images/generation-genius-video-bg-pattern.svg")
      top left / contain repeat
      ${showBlueBackground ? blue.background : orange.background}
    `,
    padding: responsiveSpacing,
  });

export const geniusFigureCss = (isVideoOnly: boolean = false) =>
  mobileFirstCss({
    margin: "0",
    minWidth: responsiveSpacing.map((val) => `calc(100% - ${val})`),
    ...(isVideoOnly
      ? { maxWidth: "900px", margin: "0 auto", minWidth: undefined }
      : {}),
  });
